<template>
    <div class="content video_content">
        <!-- <h2 class="content_title">Outro</h2> -->
        <div class="video_wrap">
            <video id="aw-video"
                class="video-js vjs-16-9 vjs-big-play-centered vjs-default-skin"
                controls
                preload="auto"
                autoplay
                :poster="'../assets/images/video_ready.png'"
                data-setup='{ "aspectRatio":"640:267", "playbackRates": [1, 1.5, 2] }'
            >
            <source  :src="videoSource" :type="videoSourceType">
            <p class="vjs-no-js">
                영상을 보시려면, 브라우져를 업그레이드 하셔야 합니다.  
                <a href="http://videojs.com/html5-video-support/" target="_blank">HTML5 영상지원 체크</a>
            </p>
            </video>
        </div>
    </div>
</template>
<script>
export default {
    props: ['currentSlide'],
    data(){
        return{
        }
    },
    computed: {
        videoSource(){
            if(this.currentSlide.source.indexOf("https://") != -1){
                return this.currentSlide.source;
            }
            if(typeof settings !== 'undefined' && settings.videoSource != null){
                var prefix = (settings.videoSource.prefix == null) ? '' : settings.videoSource.prefix;
                var suffix = (settings.videoSource.suffix == null) ? '' : settings.videoSource.suffix;
                return prefix + this.currentSlide.source + suffix;
            }
            return './videos/' + this.currentSlide.source;
        },
        videoSourceType(){
            if(this.videoSource.indexOf("m3u8") != -1){
                return 'application/x-mpegURL';
            }
            return 'video/mp4';
        }
    },
    methods:{
    },
    mounted(){
    }
}
</script>